import { getRequestLanguages, magicNumbers, mapToApiPlatform } from 'utils';
import { isNumber, isObject } from 'lib';
import { categories } from 'components/filters/components/content-category-filter/categories';
import { getKioskSearchParamsFromFilters } from 'store/kiosk/kioskSlice';
import { autoBulletinFiltersInitialState } from './initialState/autoBulletin.initialState';

export const reorderPlatforms = (platforms = []) => {
  const orderedPlatforms = [
    'news',
    'instagram',
    'instagramcomments',
    'twitter',
    'virasty',
    'telegram',
    'linkedin',
    'newspaper',
    'kiosk',
    'iranian-platforms',
    'instagramstories',
  ];
  return orderedPlatforms.filter((orderedPlatform) =>
    platforms.includes(orderedPlatform)
  );
};

export const prepareParamsForSaveAutoBulletin = (
  autoBulletinState,
  onlyDefaultParams = false
) => {
  const { currentBulletin } = autoBulletinState;

  const defaultParams = {
    title: currentBulletin?.title,
    suffix_type: currentBulletin?.suffixType,
    days: Object.keys(currentBulletin?.days).filter(
      (day) => currentBulletin?.days?.[day]
    ),
    creation_hour: currentBulletin?.creationHour,
    configs: { highlightWords: currentBulletin?.highlightWords },
    want_summary: currentBulletin.summery,
    want_news_front_page: currentBulletin?.platforms?.includes('kiosk'),
    primary_color: currentBulletin?.primaryColor,
    secondary_color: currentBulletin?.secondaryColor,
    logo: currentBulletin?.logo,
    header_type: currentBulletin?.headerType,
    enable_logo: currentBulletin?.enableLogo,
  };

  if (onlyDefaultParams) return defaultParams;

  // محاسبه تایم بر اساس ثانیه
  let timeDuration = '';
  if (currentBulletin?.timeType === magicNumbers.AUTO_BULLETIN_DAY_TIME)
    timeDuration = currentBulletin?.timeCount * magicNumbers.ONE_DAY_IN_SECONDS;
  else
    timeDuration =
      currentBulletin?.timeCount * magicNumbers.ONE_HOUR_IN_SECONDS;

  const params = {};
  currentBulletin?.platforms?.map((platform) => {
    const apiPlatform = mapToApiPlatform[platform];
    const filters = autoBulletinState?.filters[platform];

    if (platform === 'kiosk') {
      const kioskParams = {
        ...getKioskSearchParamsFromFilters(filters),
      };

      if (currentBulletin?.count) {
        kioskParams.count = +currentBulletin?.count;
      }

      params.kiosk = kioskParams;
      return;
    }

    const contentBasedFilter = filters?.contentBasedFilter?.selectedObjects;
    const sentimentFilter = filters?.sentimentFilter?.selectedValues;

    const isFilterDisabled = (filterName) =>
      isObject(filters?.[filterName])
        ? filters?.[filterName]?.isDisabled
        : true;

    const subCategories = isFilterDisabled('contentCategoryFilter')
      ? undefined
      : Object.values(filters?.contentCategoryFilter?.selectedCategories);

    params[apiPlatform] = {
      query: currentBulletin?.query,
      sort: currentBulletin?.selectedSort[platform] || 'time',
      sort_type: 'desc',
      resource_influence_categories: autoBulletinState.filters[platform]
        ?.contentBasedFilter?.selectedObjects?.influenceRate?.active
        ? autoBulletinState.filters[platform]?.contentBasedFilter
            ?.selectedObjects?.influenceRate.selectedIds
        : undefined,
      langs: isFilterDisabled('languageFilter')
        ? undefined
        : getRequestLanguages(filters),
      categories: isFilterDisabled('contentCategoryFilter')
        ? undefined
        : Object.keys(filters?.contentCategoryFilter?.selectedCategories) ||
          undefined,
      sub_categories:
        subCategories?.length > 0 ? subCategories.flat(1) : undefined,
      resource_categories: filters?.subjectFilter?.selectedIds ?? undefined,

      [filters?.resourceCategoryFilter?.filterType === 'include'
        ? 'tag_id'
        : 'not_tag_id']:
        filters?.resourceCategoryFilter?.selectedValue || undefined,

      [filters?.resourcesFilter?.selectedValue === 'include'
        ? 'resource_ids'
        : 'not_resource_ids']: isFilterDisabled('resourcesFilter')
        ? undefined
        : Object.keys(filters?.resourcesFilter?.selectedItems),
      sentiments: isFilterDisabled('sentimentFilter')
        ? undefined
        : Object.keys(sentimentFilter).filter(
            (sentiment) => sentimentFilter?.[sentiment] !== false
          ),
      min_like: contentBasedFilter?.like?.min ?? undefined,
      max_like: contentBasedFilter?.like?.max ?? undefined,
      min_reactions: contentBasedFilter?.reaction?.min ?? undefined,
      max_reactions: contentBasedFilter?.reaction?.max ?? undefined,
      min_comment: contentBasedFilter?.comment?.min ?? undefined,
      max_comment: contentBasedFilter?.comment?.max ?? undefined,
      m3_age: isFilterDisabled('ageFilter')
        ? undefined
        : filters?.ageFilter?.selectedIds || undefined,
      gender: isFilterDisabled('genderFilter')
        ? undefined
        : filters?.genderFilter?.selectedIds || undefined,
      min_copy: contentBasedFilter?.copy?.min ?? undefined,
      max_copy: contentBasedFilter?.copy?.max ?? undefined,
      min_view: contentBasedFilter?.view?.min ?? undefined,
      max_view: contentBasedFilter?.view?.max ?? undefined,
      source:
        isFilterDisabled('contentTypeFilter') ||
        filters?.contentTypeFilter?.selectedValue === 'both'
          ? undefined
          : filters?.contentTypeFilter?.selectedValue,
    };

    // اسم فیلد فیلتر نوع محتوا و نوع منبع شباهت دارن ولی مقادیرشون با توجه به پلتفرم فرق داره
    if (apiPlatform === 'news') {
      params[apiPlatform] = {
        ...params[apiPlatform],
        media_types: isFilterDisabled('resourceTypeFilter')
          ? undefined
          : autoBulletinState?.filters[platform]?.resourceTypeFilter
              ?.selectedIds ?? undefined,
        resource_countries:
          !isFilterDisabled('countryFilter') &&
          filters?.countryFilter?.selectedIds?.length > 0
            ? filters?.countryFilter?.selectedIds
            : undefined,
      };
    } else {
      params[apiPlatform] = {
        ...params[apiPlatform],
        media_types: isFilterDisabled('mediaTypeFilter')
          ? undefined
          : autoBulletinState?.filters[platform]?.mediaTypeFilter
              ?.selectedIds ?? undefined,
      };
    }

    // اگر این موارد وجود داشتن و ارایه انها خالی بود حذف بشن و با مقدار ارایه خالی ارسال نشن
    if (!params[apiPlatform]?.categories?.length)
      delete params[apiPlatform].categories;
    if (!params[apiPlatform]?.sub_categories?.length)
      delete params[apiPlatform].sub_categories;
    if (!params[apiPlatform]?.resource_ids?.length)
      delete params[apiPlatform].resource_ids;
    if (!params[apiPlatform]?.not_resource_ids?.length)
      delete params[apiPlatform].not_resource_ids;
    if (!params[apiPlatform]?.gender?.length) delete params[apiPlatform].gender;
    if (!params[apiPlatform]?.m3_age?.length) delete params[apiPlatform].m3_age;
    if (!params[apiPlatform]?.media_types?.length)
      delete params[apiPlatform].media_types;
    if (!params[apiPlatform]?.media_type?.length)
      delete params[apiPlatform].media_type;

    if (apiPlatform === 'instagram') {
      params[apiPlatform] = {
        ...params[apiPlatform],
        min_advert_noise:
          !isFilterDisabled('advertFilter') &&
          isNumber(filters?.advertFilter?.selectedObjectValues?.min)
            ? filters?.advertFilter?.selectedObjectValues?.min
            : undefined,
        max_advert_noise:
          !isFilterDisabled('advertFilter') &&
          isNumber(filters?.advertFilter?.selectedObjectValues?.max)
            ? filters?.advertFilter?.selectedObjectValues?.max
            : undefined,
      };
    }
    if (timeDuration) {
      params[apiPlatform] = {
        ...params[apiPlatform],
        time_duration: timeDuration,
      };
    }
    if (currentBulletin?.count) {
      params[apiPlatform] = {
        ...params[apiPlatform],
        count: +currentBulletin?.count,
      };
    }
  });

  return {
    ...defaultParams,
    params: params,
  };
};

export const prepareAutoBulletinData = (data, openState = false) => {
  let autoContentSubmission = true;
  let firstValueOfObject = '';

  if (
    !data?.params ||
    data?.params?.length <= 0 ||
    data?.params === null ||
    data?.params === 'null' ||
    data?.params === undefined
  ) {
    autoContentSubmission = false;
  } else {
    firstValueOfObject = data?.params[Object.keys(data?.params)[0]];
  }

  let timeType = magicNumbers.AUTO_BULLETIN_HOUR_TIME;
  let timeCount = 0;
  if (
    firstValueOfObject?.time_duration % magicNumbers.ONE_DAY_IN_SECONDS ===
    0
  ) {
    timeType = magicNumbers.AUTO_BULLETIN_DAY_TIME;
    timeCount =
      firstValueOfObject?.time_duration / magicNumbers.ONE_DAY_IN_SECONDS;
  } else {
    timeCount =
      firstValueOfObject?.time_duration / magicNumbers.ONE_HOUR_IN_SECONDS;
  }

  const selectedDays = [];
  data?.days?.map((item) => {
    selectedDays[item] = true;
  });

  return {
    open: openState,
    highlightWords: data?.highlightWords || [],
    id: data?.id,
    title: data?.title,
    active: data?.active,
    hash: data?.hash,
    suffixType: data?.suffixType,
    platforms: data?.platforms,
    days: selectedDays,
    timeType: timeType,
    timeCount: timeCount,
    step: 0,
    creationHour:
      data?.creationHour ?? magicNumbers.SMART_BULLETIN_DEFAULT_HOUR,
    count: autoContentSubmission ? firstValueOfObject?.count : '',
    selectedSort: data?.selectedSort,
    query: autoContentSubmission ? firstValueOfObject?.query : '',
    autoContentSubmission: autoContentSubmission,
    summery: data.summery,
    primaryColor: data.primaryColor,
    secondaryColor: data.secondaryColor,
    logo: data.logo,
    headerType: data.headerType,
    enableLogo: data.enableLogo,
  };
};

export const transformAdvancedFilters = (data, platform) => {
  // create a copy of alarmFiltersInitialState platform filters. don't use reference
  const filters = { ...autoBulletinFiltersInitialState[platform] };

  // resourceTypeFilter OR mediaTypeFilter
  // اسم فیلد فیلتر نوع محتوا و نوع منبع شباهت دارن ولی مقادیرشون با توجه به پلتفرم فرق داره
  if (data?.media_types?.length > 0) {
    if (platform === 'news') {
      filters.resourceTypeFilter = {
        ...filters.resourceTypeFilter,
        selectedIds: data?.media_types || [],
        hasFilter: data?.media_types?.length > 0,
        isDisabled: !(data?.media_types?.length > 0),
      };
    } else if (platform !== 'newspaper') {
      filters.mediaTypeFilter = {
        ...filters.mediaTypeFilter,
        selectedIds: data?.media_types || [],
        hasFilter: data?.media_types?.length > 0,
        isDisabled: !(data?.media_types?.length > 0),
      };
    }
  }

  // contentBasedFilter
  if (data?.resource_influence_categories) {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        influenceRate: {
          ...filters.contentBasedFilter.selectedObjects.influenceRate,
          active: Boolean(data?.resource_influence_categories),
          selectedIds: data?.resource_influence_categories,
        },
      },
    };
  }
  if (platform === 'news') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
      },
    };
  } else if (platform === 'instagram') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        comment: {
          ...filters.contentBasedFilter.selectedObjects.comment,
          active: !!data?.min_comment,
          min: data?.min_comment || null,
          max: data?.max_comment || null,
        },
        like: {
          ...filters.contentBasedFilter.selectedObjects.like,
          active: !!data?.min_like,
          min: data?.min_like || null,
          max: data?.max_like || null,
        },
      },
    };
  } else if (platform === 'telegram') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        view: {
          ...filters.contentBasedFilter.selectedObjects.view,
          active: !!data?.min_view,
          min: data?.min_view || null,
          max: data?.max_view || null,
        },
      },
    };
  } else if (platform === 'twitter') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        copy: {
          ...filters.contentBasedFilter.selectedObjects.copy,
          active: !!data?.min_copy,
          min: data?.min_copy || null,
          max: data?.max_copy || null,
        },
        like: {
          ...filters.contentBasedFilter.selectedObjects.like,
          active: !!data?.min_like,
          min: data?.min_like || null,
          max: data?.max_like || null,
        },
      },
    };
  }

  if (platform === 'virasty') {
    filters.contentBasedFilter = {
      ...filters.contentBasedFilter,
      selectedObjects: {
        ...filters.contentBasedFilter.selectedObjects,
        copy: {
          ...filters.contentBasedFilter.selectedObjects.copy,
          active: !!data?.min_copy,
          min: data?.min_copy || null,
          max: data?.max_copy || null,
        },
        reaction: {
          ...filters.contentBasedFilter.selectedObjects.reaction,
          active: !!data?.min_reactions,
          min: data?.min_reactions || null,
          max: data?.max_reactions || null,
        },
      },
    };
  }

  // subjectFilter
  if (platform === 'kiosk' && data?.kiosk_categories?.length > 0) {
    filters.subjectFilter = {
      ...filters.subjectFilter,
      selectedIds: data?.kiosk_categories || [],
      hasFilter: data?.kiosk_categories?.length > 0,
      isDisabled: !(data?.kiosk_categories?.length > 0),
    };
  } else if (data?.resource_categories?.length > 0) {
    filters.subjectFilter = {
      ...filters.subjectFilter,
      selectedIds: data?.resource_categories || [],
      hasFilter: data?.resource_categories?.length > 0,
      isDisabled: !(data?.resource_categories?.length > 0),
    };
  }

  // sentimentFilter
  if (data?.sentiments?.length > 0) {
    filters.sentimentFilter = {
      ...filters.sentimentFilter,
      hasFilter: true,
      isDisabled: false,
      selectedValues: {
        negative: data.sentiments.includes('negative'),
        neutral: data.sentiments.includes('neutral'),
        positive: data.sentiments.includes('positive'),
      },
    };
  }

  // ageFilter
  if (data?.m3_age?.length > 0) {
    filters.ageFilter = {
      ...filters.ageFilter,
      selectedIds: data?.m3_age || [],
      hasFilter: data?.m3_age?.length > 0,
      isDisabled: !(data?.m3_age?.length > 0),
    };
  }

  // genderFilter
  if (data?.gender?.length > 0) {
    filters.genderFilter = {
      ...filters.genderFilter,
      selectedIds: data?.gender || [],
      hasFilter: data?.gender?.length > 0,
      isDisabled: !(data?.gender?.length > 0),
    };
  }

  // resourceCategoryFilter
  if (data?.tag_id || data?.not_tag_id) {
    const isInclude = !!data?.tag_id;
    const hasValue = !!data?.tag_id || !!data?.not_tag_id;
    filters.resourceCategoryFilter = {
      ...filters.resourceCategoryFilter,
      selectedValue: isInclude ? data.tag_id : data.not_tag_id,
      filterType: isInclude ? 'include' : 'exclude',
      hasFilter: hasValue,
      isDisabled: !hasValue,
    };
  }

  // resourcesFilter
  if (data?.resource_ids?.length > 0 || data?.not_resource_ids?.length > 0) {
    const _resourceIds = {};

    data?.resource_ids?.forEach((key) => {
      _resourceIds[key] = {
        title: key,
        id: key,
      };
    });
    data?.not_resource_ids?.forEach((key) => {
      _resourceIds[key] = {
        title: key,
        id: key,
      };
    });

    filters.resourcesFilter = {
      ...filters.resourcesFilter,
      selectedItems: _resourceIds,
      selectedValue: data?.resource_ids?.length > 0 ? 'include' : 'exclude',
      hasFilter:
        data?.resource_ids?.length > 0 || data?.not_resource_ids?.length > 0,
      isDisabled:
        !(data?.resource_ids?.length > 0) &&
        !(data?.not_resource_ids?.length > 0),
    };
  }

  // countryFilter
  if (data?.resource_countries?.length > 0) {
    filters.countryFilter = {
      ...filters.countryFilter,
      selectedIds: data?.resource_countries || [],
      hasFilter: data?.resource_countries?.length > 0,
      isDisabled: !(data?.resource_countries?.length > 0),
    };
  }

  // languageFilter
  if (data?.langs?.length > 0) {
    filters.languageFilter = {
      ...filters.languageFilter,
      selectedValue: data?.langs?.[0] || 'all',
      hasFilter: data?.langs?.[0] !== 'all',
      isDisabled: data?.langs?.[0] === 'all',
    };
  }

  // contentCategoryFilter
  if (data?.categories?.length > 0) {
    const _categories = {};

    data?.categories?.forEach((key) => {
      _categories[key] = [];
    });

    Object.keys(_categories)?.map((cat) => {
      categories?.[cat]?.forEach((subCat) => {
        if (data?.sub_categories?.includes(subCat))
          _categories[cat].push(subCat);
      });
    });

    filters.contentCategoryFilter = {
      ...filters.contentCategoryFilter,
      selectedCategories: _categories,
      hasFilter: !!_categories,
      isDisabled: !_categories,
    };
  }

  if (data?.source) {
    filters.contentTypeFilter = {
      ...filters.contentTypeFilter,
      isDisabled: false,
      selectedValue: data?.source,
    };
  }

  if (isNumber(data?.min_advert_noise) || isNumber(data?.max_advert_noise)) {
    filters.advertFilter = {
      ...filters.advertFilter,
      selectedObjectValues: {
        ...filters.selectedObjectValues,
        min: data?.min_advert_noise,
        max: data?.max_advert_noise,
        active: true,
      },
      isDisabled: false,
    };
  }

  return filters;
};
